import { ThreeViewFieldsDataSource } from '../models/three-view-fields-data-source';
import { RouteConstants } from '../constants/route.constant';
import { RoleType } from '@goatsports/core/data-access';

type RolePermissions = Partial<{
  [key in RoleType]: ThreeViewFieldsDataSource[];
}>;

export const ROLE_PERMISSIONS: RolePermissions = {
  [RoleType.SuperAdmin]: [
    {
      id: `/${RouteConstants.DASHBOARD_ROUTE}`,
      text: 'Dashboard',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.HABITS_ROUTE}`,
      text: 'Habits',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.WORKOUTS_ROUTE}`,
      text: 'Workouts',
      iconCss: 'e-icons',
    },

    {
      id: `/${RouteConstants.MEALS_ROUTE}`,
      text: 'Meals',
      iconCss: 'e-icons',
    },

    // {
    //   id: `/${RouteConstants.DAILY_WORKOUTS_ROUTE}`,
    //   text: 'Daily Workouts',
    //   iconCss: 'e-icons',
    //   hasChildren: true,
    // },

    // {
    //   id: `/${RouteConstants.DAILY_MEALS_ROUTE}`,
    //   text: 'Daily Meals',
    //   iconCss: 'e-icons',
    //   hasChildren: true,
    // },
    {
      id: `/${RouteConstants.QUIZ_ROUTE}`,
      text: 'Quiz',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.REFLECTIONS_ROUTE}`,
      text: 'Reflections',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.ASSESSMENTS_ROUTE}`,
      text: 'Assessments',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.ANNOUNCEMENTS_ROUTE}`,
      text: 'Announcements',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.ADMINS_ROUTE}`,
      text: 'Admins',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.ORGANIZATIONS_ROUTE}`,
      text: 'Organizations',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.BUNDLES_ROUTE}`,
      text: 'Bundles',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.SETTINGS_ROUTE}`,
      text: 'Settings',
      iconCss: 'e-icons',
    },
  ],
  [RoleType.OrganizationAdmin]: [
    {
      id: `/${RouteConstants.DASHBOARD_ROUTE}`,
      text: 'Dashboard',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.CLIENTS_ROUTE}`,
      text: 'Clients',
      iconCss: 'e-icons',
    },
    {
      id: `/${RouteConstants.GROUPS_ROUTE}`,
      text: 'Groups',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.HABITS_ROUTE}`,
      text: 'Habits',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.WORKOUTS_ROUTE}`,
      text: 'Workouts',
      iconCss: 'e-icons',
    },

    {
      id: `/${RouteConstants.MEALS_ROUTE}`,
      text: 'Meals',
      iconCss: 'e-icons',
    },

    {
      id: `/${RouteConstants.QUIZ_ROUTE}`,
      text: 'Quiz',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.REFLECTIONS_ROUTE}`,
      text: 'Reflections',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.ASSESSMENTS_ROUTE}`,
      text: 'Assessments',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.ANNOUNCEMENTS_ROUTE}`,
      text: 'Announcements',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.COACHES_ROUTE}`,
      text: 'Coaches',
      iconCss: 'e-icons',
    },
    {
      id: `/${RouteConstants.TEAMS_ROUTE}`,
      text: 'Teams',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.ADMINS_ROUTE}`,
      text: 'Admins',
      iconCss: 'e-icons',
    },
    {
      id: `/${RouteConstants.ORGANIZATION_SETTINGS_ROUTE}`,
      text: 'Settings',
      iconCss: 'e-icons',
    },
  ],
  [RoleType.Coach]: [
    {
      id: `/${RouteConstants.DASHBOARD_ROUTE}`,
      text: 'Dashboard',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.CLIENTS_ROUTE}`,
      text: 'Clients',
      iconCss: 'e-icons',
    },

    {
      id: `/${RouteConstants.GROUPS_ROUTE}`,
      text: 'Groups',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.HABITS_ROUTE}`,
      text: 'Habits',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.WORKOUTS_ROUTE}`,
      text: 'Workouts',
      iconCss: 'e-icons',
    },

    {
      id: `/${RouteConstants.MEALS_ROUTE}`,
      text: 'Meals',
      iconCss: 'e-icons',
    },

    {
      id: `/${RouteConstants.QUIZ_ROUTE}`,
      text: 'Quiz',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.REFLECTIONS_ROUTE}`,
      text: 'Reflections',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.ASSESSMENTS_ROUTE}`,
      text: 'Assessments',
      iconCss: 'e-icons',
      hasChildren: true,
    },
    {
      id: `/${RouteConstants.ANNOUNCEMENTS_ROUTE}`,
      text: 'Announcements',
      iconCss: 'e-icons',
      hasChildren: true,
    },

    {
      id: `/${RouteConstants.COACHES_ROUTE}`,
      text: 'Coaches',
      iconCss: 'e-icons',
    },
  ],
  [RoleType.Translator]: [
    {
      id: `/${RouteConstants.CONFIGURE_ROUTE}`,
      text: 'Settings',
      iconCss: 'e-icons',
    },
  ],
};
